import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    standalone: false
})
export class DatePickerComponent implements OnInit {

    private lastInvalidVal?: string;
    private _lastDate: NgbDateStruct | undefined;

    constructor() { }

    ngOnInit(): void {
    }

    @Input()
    id?: string;

    @Input()
    date: Date | undefined = undefined;

    @Output()
    dateChange = new EventEmitter<Date | undefined>();

    get dateId() { return this.id ? `${this.id}-date` : undefined }

    get dateStruct(): NgbDateStruct | string | undefined {
        let d = this.date;
        if (!d)
            return this.lastInvalidVal;
        let result = {
            day: d.getDate(),
            month: d.getMonth() + 1,
            year: d.getFullYear()
        };
        if (this._lastDate
            && this._lastDate.day === result.day
            && this._lastDate.month === result.month
            && this._lastDate.year === result.year)
            return this._lastDate;
        this._lastDate = result;
        return result;
    }

    set dateStruct(val: NgbDateStruct | string | undefined) {
        if (!val || typeof val == "string") {
            this.lastInvalidVal = val;
            this.date = undefined;
            this.dateChange.emit(undefined);
            return;
        }
        let d = this.date ?? new Date();
        d.setFullYear(val.year);
        d.setMonth(val.month - 1);
        d.setDate(val.day);
        this.date = d;
        this.dateChange.emit(d);
    }

    faCalendar = faCalendar;
}
